// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-menu .navbar-nav > .open > a,
.main-menu .navbar-nav > .open > a:focus,
.main-menu .navbar-nav > .active > a,
.main-menu .navbar-nav > .active > a:focus,
.main-menu .navbar-nav > li > a:hover,
.main-menu .navbar-nav > li > a:focus,
.main-menu .dropdown-menu > li > a:hover,
.main-menu .dropdown-menu > li > a:focus,
.main-menu .dropdown-menu > .active > a,
.main-menu .navbar-nav .open .dropdown-menu > li > a:hover,
.main-menu .navbar-nav .open .dropdown-menu > li > a:focus {
	color: #ecc243 !important;
}

.timetable-search .dropdown-menu > li > a:hover,
.timetable-search .dropdown-menu > li > a:focus,
.timetable-search .dropdown-menu > .active > a {
	color: #ecc243 !important;
}

.bg-light {
	color: #ecc243;
}

a:not(.btn) {
	color: #ecc243;
}

.main-menu-toggle .icon-bar {
	background-color: #ecc243 !important;
}

.booking-options-container .glyphicon {
	color: #ecc243;
}

.payment-methods label.checked {
	border-color: #ecc243;
}

.btn-primary, .btn-primary.disabled:hover, .btn-primary[disabled]:hover, fieldset[disabled] .btn-primary:hover, .btn-primary.disabled:focus, .btn-primary[disabled]:focus, fieldset[disabled] .btn-primary:focus, .btn-primary.disabled.focus, .btn-primary[disabled].focus, fieldset[disabled] .btn-primary.focus {
	background-color: #3c1160;
	border-color: #4a0d6f
}

	.btn-primary:focus, .btn-primary.focus {
		background-color: #4a0d6f;
		border-color: #4a0d6f
	}

	.btn-primary:hover, .btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {
		background-color: #4a0d6f;
		border-color: #4a0d6f
	}

		.btn-primary:active:hover, .btn-primary.active:hover, .open > .dropdown-toggle.btn-primary:hover, .btn-primary:active:focus, .btn-primary.active:focus, .open > .dropdown-toggle.btn-primary:focus, .btn-primary:active.focus, .btn-primary.active.focus, .open > .dropdown-toggle.btn-primary.focus {
			background-color: #4a0d6f;
			border-color: #4a0d6f
		}

.register-steps .steps_s {
	border-bottom-color: #3c1160;
}

	.register-steps .steps_s:after {
		background-color: #3c1160;
	}

	.register-steps .steps_s .number {
		color: #3c1160;
	}

	.register-steps .steps_s .title {
		color: #3c1160;
	}

.steps_title {
	color: #3c1160;
}

.child-details-sidebar .nav > li > a:hover,
.child-details-sidebar .nav > li > a:focus,
.child-details-sidebar .nav > li.active > a,
.child-details-sidebar .nav > li.active > a:hover,
.child-details-sidebar .nav > li.active > a:focus {
	color: #ecc243 !important;
}
`, "",{"version":3,"sources":["webpack://./theme/css/themes/littlelearners.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;CAWC,yBAAyB;AAC1B;;AAEA;;;CAGC,yBAAyB;AAC1B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,yBAAyB;CACzB;AACD;;CAEC;EACC,yBAAyB;EACzB;CACD;;CAEA;EACC,yBAAyB;EACzB;CACD;;EAEC;GACC,yBAAyB;GACzB;EACD;;AAEF;CACC,4BAA4B;AAC7B;;CAEC;EACC,yBAAyB;CAC1B;;CAEA;EACC,cAAc;CACf;;CAEA;EACC,cAAc;CACf;;AAED;CACC,cAAc;AACf;;AAEA;;;;;CAKC,yBAAyB;AAC1B","sourcesContent":[".main-menu .navbar-nav > .open > a,\r\n.main-menu .navbar-nav > .open > a:focus,\r\n.main-menu .navbar-nav > .active > a,\r\n.main-menu .navbar-nav > .active > a:focus,\r\n.main-menu .navbar-nav > li > a:hover,\r\n.main-menu .navbar-nav > li > a:focus,\r\n.main-menu .dropdown-menu > li > a:hover,\r\n.main-menu .dropdown-menu > li > a:focus,\r\n.main-menu .dropdown-menu > .active > a,\r\n.main-menu .navbar-nav .open .dropdown-menu > li > a:hover,\r\n.main-menu .navbar-nav .open .dropdown-menu > li > a:focus {\r\n\tcolor: #ecc243 !important;\r\n}\r\n\r\n.timetable-search .dropdown-menu > li > a:hover,\r\n.timetable-search .dropdown-menu > li > a:focus,\r\n.timetable-search .dropdown-menu > .active > a {\r\n\tcolor: #ecc243 !important;\r\n}\r\n\r\n.bg-light {\r\n\tcolor: #ecc243;\r\n}\r\n\r\na:not(.btn) {\r\n\tcolor: #ecc243;\r\n}\r\n\r\n.main-menu-toggle .icon-bar {\r\n\tbackground-color: #ecc243 !important;\r\n}\r\n\r\n.booking-options-container .glyphicon {\r\n\tcolor: #ecc243;\r\n}\r\n\r\n.payment-methods label.checked {\r\n\tborder-color: #ecc243;\r\n}\r\n\r\n.btn-primary, .btn-primary.disabled:hover, .btn-primary[disabled]:hover, fieldset[disabled] .btn-primary:hover, .btn-primary.disabled:focus, .btn-primary[disabled]:focus, fieldset[disabled] .btn-primary:focus, .btn-primary.disabled.focus, .btn-primary[disabled].focus, fieldset[disabled] .btn-primary.focus {\r\n\tbackground-color: #3c1160;\r\n\tborder-color: #4a0d6f\r\n}\r\n\r\n\t.btn-primary:focus, .btn-primary.focus {\r\n\t\tbackground-color: #4a0d6f;\r\n\t\tborder-color: #4a0d6f\r\n\t}\r\n\r\n\t.btn-primary:hover, .btn-primary:active, .btn-primary.active, .open > .dropdown-toggle.btn-primary {\r\n\t\tbackground-color: #4a0d6f;\r\n\t\tborder-color: #4a0d6f\r\n\t}\r\n\r\n\t\t.btn-primary:active:hover, .btn-primary.active:hover, .open > .dropdown-toggle.btn-primary:hover, .btn-primary:active:focus, .btn-primary.active:focus, .open > .dropdown-toggle.btn-primary:focus, .btn-primary:active.focus, .btn-primary.active.focus, .open > .dropdown-toggle.btn-primary.focus {\r\n\t\t\tbackground-color: #4a0d6f;\r\n\t\t\tborder-color: #4a0d6f\r\n\t\t}\r\n\r\n.register-steps .steps_s {\r\n\tborder-bottom-color: #3c1160;\r\n}\r\n\r\n\t.register-steps .steps_s:after {\r\n\t\tbackground-color: #3c1160;\r\n\t}\r\n\r\n\t.register-steps .steps_s .number {\r\n\t\tcolor: #3c1160;\r\n\t}\r\n\r\n\t.register-steps .steps_s .title {\r\n\t\tcolor: #3c1160;\r\n\t}\r\n\r\n.steps_title {\r\n\tcolor: #3c1160;\r\n}\r\n\r\n.child-details-sidebar .nav > li > a:hover,\r\n.child-details-sidebar .nav > li > a:focus,\r\n.child-details-sidebar .nav > li.active > a,\r\n.child-details-sidebar .nav > li.active > a:hover,\r\n.child-details-sidebar .nav > li.active > a:focus {\r\n\tcolor: #ecc243 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
